import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type RecentsContextValue = {
    deleteFromHistory: (sku: string) => void;
    deleteRecentsHistory: () => void;
};

type RecentsContextProviderProps = {
    deleteFromHistory: (sku: string) => void;
    deleteRecentsHistory: () => void;
    children: ReactNode;
};

export const RecentsContext = createContext<RecentsContextValue | undefined>(
    undefined
);

export const RecentsContextProvider = ({
    deleteFromHistory,
    deleteRecentsHistory,
    children
}: RecentsContextProviderProps) => {
    return (
        <RecentsContext.Provider
            value={{
                deleteFromHistory: deleteFromHistory,
                deleteRecentsHistory: deleteRecentsHistory
            }}
        >
            {children}
        </RecentsContext.Provider>
    );
};

export const useRecentsContext = () => {
    const context = use<RecentsContextValue | undefined>(RecentsContext);

    if (!isDefined(context)) {
        throw new Error(`${RecentsContext.displayName} is undefined.`);
    }

    return context;
};
